<template>
  <v-app>
    <v-toolbar app color="primary" class="toolbar">
      <v-container fluid pa-0 class="my__toolbar">
        <v-row class="align-center justify-center row">
          <v-col class="col-4 col-md-5 disappear-mobile">
            <v-btn
              href="/"
              width="90px"
              height="35px"
              color="white"
              class="navbar-buttons primary--text btn-return"
            >
              <v-icon>keyboard_arrow_left</v-icon>Voltar
            </v-btn>
          </v-col>
          <v-col class="col-8 col-md-2">
            <v-row class="align-md-center justify-md-center row">
              <img
                :src="require('../../assets/ondivan_marca_white.svg')"
                width="220px"
              />
            </v-row>
          </v-col>
          <v-col
            class="col-5 col-md-5 d-none d-md-block disappear-mobile"
          ></v-col>
        </v-row>
      </v-container>
    </v-toolbar>

    <BaseFaq />
  </v-app>
</template>
<script>
import BaseFaq from '@/components/BaseFaq.vue';
export default {
  components: {
    BaseFaq,
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.image-team {
  width: 100%;
  /* height: 50%; */
  object-fit: cover;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
  .image-team {
    height: 100%;
  }
}
</style>
